import DefaultFormFields from '@entity/EntityForm/Fields';

// We can import additional Components here to expand or overwrite Boilerplate Components
const FormFields = Object.assign(DefaultFormFields, {});

export default FormFields;
